import LeanLogoAnimated from './LeanLogoAnimated';

export default LeanLogoAnimated;
